<!-- <div class="container"> -->
<div class="breadcrumbs--page-nav">
  <div class="container">
    <p>
      <a routerLink="/">{{"statictext.home" | cxTranslate}}</a>
      <span> &gt; </span>
      <strong>{{"statictext.about" | cxTranslate}}</strong>
    </p>
  </div>
</div>

@if (aboutus | async; as item){
@if(item.uid === "seqirusAboutageFirstcomponent"){
  <section class="aboutpagebanner" id="aboutpagebanner">
  <div class="aboutpage_Topcontainer">
    <div class="bannerImagewrap">
      <picture>
        <source [srcset]="getImage(item.media.widescreen)" media="(min-width: 1700px)">
        <source [srcset]="getImage(item.media.tablet)" media="(min-width: 1024px) and (max-width:1399px)">
        <img class="about_flu-doctor" alt="Flu vaccine doctor" [src]="getImage(item.media.desktop)">
      </picture>
    </div>
    <div class="aboutpage_bannercontent">
      <div class="contentwrapper">
      <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
      <div class="aboutbannerHeader" [innerHTML]="item.content"></div>
      <div class="aboutbannersubHeader" [innerHTML]="item.headline"></div>
      <div class="aboutbanner_btn">
        <button class="aboutbanner_crtbtn"  [routerLink]="'/createprofile'">
        <span class="aboutcrtbtn_text" [innerHTML]="item.largeparagraphcontent"></span>
        <img alt="Next screen" src="../../../app/../assets/images/arrow-right-white.svg" class="crtbtn-arrow">
        </button>
      </div>
      </div>
    </div>
  </div>
  </section>
}
}

@if (aboutus | async; as item) {
  @if(item.uid !== "seqirusAboutageFirstcomponent"){
  <div class="hero--overview" role="img" aria-label="Healthcare professional facing left">
    <div class="container">
      <div class="hero--overview-content">
        <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
        <h1 class="content">{{item.content}}</h1>
        <p class="about-us" [innerHTML]="item.largeparagraphcontent"></p>
        <p class="ready-ref" [innerHTML]="item.headline"></p>
        <a [routerLink]="'/createprofile'">
          <button class="button--hero-solid-red mt-20">
          {{"statictext.createAccount" | cxTranslate}}</button>
        </a>
      </div>
    </div>
  </div>
}
}

<!--hide desktop -->
@if (aboutus | async; as item) {
  @if(item.uid !== "seqirusAboutageFirstcomponent"){
  <div class="row-flex center-xs mobile_Overview_Content">
    <div class="hero--overview-content-mobile hide-desktop">
      <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
      <!-- <div class="mobile_overview_title">At the forefront of flu prevention</div> -->
      <div class="content">{{item.content}}</div>
      <p class="about-us" [innerHTML]="item.largeparagraphcontent"></p>
      <p class="ref" [innerHTML]="item.headline"></p>
      <a [routerLink]="'/createprofile'" class="mobile_CreateProfile_Btn">
        <button class="button--hero-solid-red">
        {{"statictext.createAccount" | cxTranslate}}</button>
      </a>
    </div>
  </div>
}
}
